import { init } from './init';
import {
  getCurrentUser,
  getMultiFactor,
  onAuthStateChanged,
  signInWithGooglePopup,
  signInWithEmail,
  verifyEmail,
  resetPassword,
  signOut,
  reauthenticateWithEmailAndPassword,
  reauthenticateWithGooglePopup,
  getMultiFactorResolverWithError,
  PhoneMultiFactorGenerator,
  handlePhoneMultiFactor,
  resolvePhoneMultiFactor,
  sendVerificationCode,
  verifyCodeAndEnrollPhoneNumber,
  TotpMultiFactorGenerator,
  genTotpSecret,
  verifyCodeAndEnrollTotp,
} from './auth';

export default {
  init,
  /** auth */
  getCurrentUser,
  getMultiFactor,
  onAuthStateChanged,
  signInWithGooglePopup,
  signInWithEmail,
  verifyEmail,
  resetPassword,
  signOut,
  reauthenticateWithEmailAndPassword,
  reauthenticateWithGooglePopup,
  getMultiFactorResolverWithError,
  PhoneMultiFactorGenerator,
  handlePhoneMultiFactor,
  resolvePhoneMultiFactor,
  sendVerificationCode,
  verifyCodeAndEnrollPhoneNumber,
  TotpMultiFactorGenerator,
  genTotpSecret,
  verifyCodeAndEnrollTotp,
};
